<template>
    <a-entity>

        <a-entity
            :position-from-sky="position"
        >
            <a-image
                :width="infospot.width"
                :height="infospot.height"
                :src="infospot.icon"
                class="clickable close_on_active"
                hover-effect-scale="scale: 1.25"
                @click="onClick"
                play-sound="audio: #audio-bop; events: click"
                :toggle-modal="'#modal-'+infospot.id"
                :tooltip="infospot.tooltip"
                :showline="infospot.xyz"
            ></a-image>
        </a-entity>

        <!--        <a-entity :id="'modal-'+infospot.id" :visible="infospot.initially_opened" modal>-->
        <!--        </a-entity>-->

        <a-entity
            :id="'modal-'+infospot.id"
            advanced-visible="false"
            :modal="modalAttributeString"
            :class="{intro_panel: infospot.initially_opened}"
        >
            <info-spot-content :infospot="infospot"></info-spot-content>
        </a-entity>
      
    </a-entity>

</template>

<script>
import InfoSpotContent from "./InfoSpotContent";
import {aFramePropertyString} from './util';

export default {
    name: "InfoSpot",
    props: ['infospot'],
    components: {InfoSpotContent},
    data: function () {
        return {}
    },
    computed: {
        position: function () {
            return {
                skyPosition: this.infospot.xyz,
                distance: 5,
            }
        },
        modalAttributeString: function() {
            const me = this;
            return aFramePropertyString({
                // initiallyOpen: me.infospot.initially_opened ? 'true':'false',
                initialPosition: me.infospot.xyz.x + ' ' + me.infospot.xyz.y + ' ' + me.infospot.xyz.z,
            });
        }
    },
    created: function () {
        const me = this;
    },
    methods: {
        onClick() {
            this.$emit('infospot-click');
        }
    }
}
</script>

<style scoped>

</style>